export default "__VITE_ASSET__C8B4JeDb__"